import Observable from './observable';
import BaseObject from '../base/base_object';
import DOM from './dom';
import TimeSpan from './time_span';
import {TimeIntervalName} from '../../../common/utils/time-interval-names';

export default class ObservableFactory extends BaseObject {
    static CLASS = "ObservableFactory";

    private _getTimeInMilliseconds(time: TimeSpan | number) : number {
        if (typeof time === 'number') {
            return time;
        }

        return (time as TimeSpan).totalMilliseconds;
    }

    fromTimeout(timeout: TimeSpan | number, name?: TimeIntervalName) : Observable {
        let timeoutInMilliseconds = this._getTimeInMilliseconds(timeout);

        return new Observable((observer) => {
            const callback = () => {
                observer.onNext();
                observer.onCompleted();
            };

            let handler = DOM.setTimeout(callback, timeoutInMilliseconds, name);

            return {
                dispose: () => DOM.clearTimeout(handler)
            };
        });
    }

    fromInterval(interval: TimeSpan | number, name?: TimeIntervalName) : Observable {
        let intervalInMilliseconds = this._getTimeInMilliseconds(interval);

        return new Observable((observer) => {
            let handler: number;
            const callback = () => observer.onNext();
            handler = DOM.setInterval(callback, intervalInMilliseconds, name);

            return {
                dispose: () => DOM.clearInterval(handler)
            };
        });
    }

    fromEvent(element: HTMLElement, eventName: string, options: any) : Observable {
        return new Observable((observer) => {
           let handler = (e) => observer.onNext(e);
           let subscription = DOM.addEventListener(element, eventName, handler, options);

           // returns a subscription object
           return {
               dispose: () => {
                   subscription.remove();
               }
           }
        });
    }
}